/* global analytics_data */
import { analyticsEvent } from '../../controllers/analytics-controller';

var HeadlineSearchController = function ($location, searchService, searchBootstrapper,$timeout) {
    "use strict";

    this.searchService = searchService;
    this.searchBootstrapper = searchBootstrapper;
    this.location = $location;
    
    this.update = function () {
        //Create HeadlinesOnly Filter if not exist
        var filter = this.searchService.getFilter('headlinesOnly');
        if (!filter) {
            this.searchBootstrapper.createFilter('headlinesOnly', '1');
        } else {
            if (filter._value === '1') {
                filter.setValue('');
            } else {
                filter.setValue('1');
                //Analytics event tracking
                analyticsEvent($.extend(analytics_data, {
                    event_name: 'search_utility',
                    search_utility: 'search_headlines_only'
                }));
            }
        }

        this.searchService._isNewSearch = true;
        this.searchService.getFilter('page').setValue("1");

        var routerBuilder = this.searchService.getRouteBuilder();
        var searchResults = this.searchService.getResults();
        if (searchResults.length > 0) {
            this.location.search(routerBuilder.getRoute());
        }
        else {
          if (angular.element(document.body).hasClass('theme-omdia')) {
            this.location.search("q=" + this.searchService.getFilter('q') + "&page=1&sortBy=relevance&sortOrder=desc");
          } else {
            this.location.search("q=" + this.searchService.getFilter('q') + "&page=1&sortBy=date&sortOrder=desc");
          }
        }
        this.searchService.query();
    };

    this.init = function () {
        var filter = this.searchService.getFilter('headlinesOnly');
        return filter !== undefined;
    }
};
var informaSearchApp = angular.module('informaSearchApp');
informaSearchApp.controller("HeadlineSearchController", ['$location', 'searchService', 'searchBootstrapper', '$timeout', HeadlineSearchController]);
